import Api from "."

interface IBillPhone {
    line_number: string
    operator_id: number
}

export const phoneMobileInquiryApi = (data: IBillPhone) => Api.POST({
    url: '/v1/phone_mobile_inquiry',
    data
})

interface IGweBill {
    bill_code?: string
    participate_code?: string
}

export const gweBillInquiryApi = (data: IGweBill) => Api.POST({
    url: '/v1/gwe_bill_inquiry',
    data
})

interface IBillPayment {
    bill_code: string
    pay_id: string
    mobile_number?: number
    amount: number
    add_to_my_bill: boolean
}

export const billPaymentApi = (data: IBillPayment) => Api.POST({
    url: '/v1/bill_payment',
    data
})
